import React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { cn } from '@Utils/index';

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item
    ref={ref}
    className={cn('naxatw-border-b', className)}
    {...props}
  />
));
AccordionItem.displayName = 'AccordionItem';

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header className="naxatw-flex naxatw-w-full naxatw-pb-[1px]">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        'naxatw-flex naxatw-flex-1 naxatw-items-center naxatw-justify-between naxatw-gap-2 naxatw-py-4 naxatw-text-left naxatw-font-medium naxatw-transition-all hover:naxatw-underline [&[data-state=open]>svg]:naxatw-rotate-180',
        className,
      )}
      {...props}
    >
      {children}
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className={cn(
      'naxatw-overflow-hidden naxatw-text-sm naxatw-transition-all data-[state=closed]:naxatw-animate-accordion-up data-[state=open]:naxatw-animate-accordion-down',
      className,
    )}
    {...props}
  >
    <div>{children}</div>
  </AccordionPrimitive.Content>
));
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
